import Link from "../../../../src/components/Portfolio/Link";
import * as React from 'react';
export default {
  Link,
  React
};